




















































import { Component, Mixins, Vue } from "vue-property-decorator";
import { getCollectHistory } from "@/apis";
import ContainImage from "@/components/ContainImage.vue";
import ImageButton from "@/components/ImageButton.vue";
import TextLabel from "@/components/TextLabel.vue";
import Overlay from "@/components/Overlay.vue";
import SettingMixin from "@/mixins/settingMixin";
import Moment from "moment";

@Component({
  components: {
    ContainImage,
    ImageButton,
    TextLabel,
    Overlay,
  },
  filters: {
    dateFormat: (timeptamp: string, format: string) => {
      Moment.locale("ja");
      return Moment(timeptamp).format(format);
    },
  },
})
export default class CollectionHistory extends Mixins(Vue, SettingMixin) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  collectHistory: any[] = [];
  isMounted = false;

  async mounted(): Promise<void> {
    const isOpen = await this.checkCampaignStatus();
    if (!isOpen) return;
    const isWin = await this.checkIsWin();
    if (isWin) return;
    // postActionLog(
    //   this.campaignId,
    //   this.token,
    //   this.serialCode,
    //   "",
    //   "collectionHistory"
    // );
    try {
      const res = await getCollectHistory(this.campaignId, this.token);
      this.collectHistory = res.data.collect_history;
      this.isMounted = true;
    } catch (e) {
      this.routerPushSystemErrorPage();
    }
  }

  onClickToCampaignPage(): void {
    this.pushWithTransition(this.routerPushCampaignPage);
  }
}
